

export const tableData = {
  tHead: [
    {
      key: 'index',
      dataIndex: 'index',
      title: '序号',
      width: 50,
      slot: 'index',
      align:'center'
    },
    {
      key: 'workunit',
      dataIndex: 'workunit',
      title: '单位',
      align:'center'
    },
    {
      key: 'id',
      dataIndex: 'id',
      title: '用户ID',
      align:'center'
    },
    {
      key: 'name',
      dataIndex: 'name',
      title: '姓名',
      align:'center'
    },
    {
      key: 'mobile',
      dataIndex: 'mobile',
      title: '手机号',
      align:'center'
    },
    // {
    //   key: 'clerkdepartment',
    //   dataIndex: 'clerkdepartment',
    //   title: '部门',
    // },
    // {
    //   key: 'clerkposition',
    //   dataIndex: 'clerkposition',
    //   title: '职务',
    // },
    {
      key: 'operate1',
      dataIndex: 'operate1',
      title: '编辑',
      width: 100,
      slot: 'operate1',
      align:'center'
    },
  ],
  tBody: [],
  tPage: {
    total: 0,
    page: 1,
    pageSize: 10
  }
};
